import React from 'react';

import { Select } from '@gogame/components';
import { useScreenDispatch } from '@gogame/screens';

import { SET_CHART_BREAKDOWN } from 'scenes/Trackers/Tracker/reducers';

import { useChartIndex, useChartState } from '../hooks';

const TOP_CHART_DROPDOWN = [
  { id: 3, name: '3' },
  { id: 5, name: '5' },
  { id: 10, name: '10' },
];

export const SelectBreakdownCount = () => {
  const chartIndex = useChartIndex();
  const chartState = useChartState();
  const dispatch = useScreenDispatch();

  const handleChangeBreakdownCount = (_e, value) => {
    dispatch({
      type: SET_CHART_BREAKDOWN,
      payload: {
        index: chartIndex,
        value: {
          ...chartState.breakdown,
          topItemsCount: value,
        },
      },
    });
  };

  return (
    <Select
      style={{ marginRight: '16px', maxWidth: '64px' }}
      options={TOP_CHART_DROPDOWN}
      label={'Top'}
      value={chartState.breakdown.topItemsCount}
      onChange={handleChangeBreakdownCount}
      dropdownWidth={100}
      withFilter={false}
    />
  );
};
